import { Box } from "@mui/material";
import { ClinicalPractitionerSelect } from "./ClinicalPractitionerSelect";
import type { ClinicalPractitionerEntry } from "src-next/modules/clinical-insights/types/analysisTypes";

interface ClinicalInsightsFilterBarProps {
  practitionerId: string;
  onPractitionerChange: (value: string) => void;
  practitioner?: ClinicalPractitionerEntry[];
  showPractitionerSelect?: boolean;
}

/** Barra superior só com profissional. O período fica no cabeçalho do frame. */
export function ClinicalInsightsFilterBar({
  practitionerId,
  onPractitionerChange,
  practitioner,
  showPractitionerSelect = true,
}: ClinicalInsightsFilterBarProps) {
  if (!showPractitionerSelect) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: { xs: "stretch", md: "flex-end" },
      }}
    >
      <ClinicalPractitionerSelect
        practitionerId={practitionerId}
        onPractitionerChange={onPractitionerChange}
        practitioner={practitioner}
      />
    </Box>
  );
}
